module.exports = __webpack_public_path__ + "img/PT191.37929e10.png";